module.exports = __webpack_public_path__ + "img/topimg1.8547027e.png";